export default "__VITE_ASSET__DdgG9rP3__"